import api from "../../../services/api-configuration";

// Blockage types (backend: /api/v1/blockingTypes, /api/v1/saveBlockingType)
export const getBlockingTypes = async () => (await api.post("/blockingTypes", {})).data;
export const saveBlockingType = async (code, values) => (await api.post("/saveBlockingType", { code, values })).data;
